import { FullSyncTrigger, OperationMode, SyncJobStatus } from "@/apollo/types";

export const isFullSync = (
  fullSyncTrigger: FullSyncTrigger | null | undefined,
  operationMode?: OperationMode,
) => {
  if (operationMode === OperationMode.Full) {
    return true;
  }
  return (
    fullSyncTrigger != null &&
    ![FullSyncTrigger.None, FullSyncTrigger.Lookback].includes(fullSyncTrigger)
  );
};

const FAILED_SYNC_STATUSES: ReadonlySet<SyncJobStatus> = new Set([
  SyncJobStatus.Failed,
  SyncJobStatus.Delayed,
  SyncJobStatus.Retrying,
]);

export const isFailedSyncStatus = (status: SyncJobStatus | null | undefined) =>
  status != null && FAILED_SYNC_STATUSES.has(status);
